// src/plugins/form-create.ts
import type { App } from 'vue';
import formCreate from '@form-create/naive-ui';
import install from '@form-create/naive-ui/auto-import'
formCreate.use(install)

export function setupFormCreate(app: App) {
  app.use(formCreate);
}
